import { Pagination } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type UserPageState = {
  dataAllUserPage: UserPageType[];
  dataDetailUserPage?: UserPageDetailType;
  pagination: PaginationAPI;
  totalElements?: number;
  dataPermissionsUserDetail?: FunctionPermissionUserPageType[];
  dataActionPermissionUserDetail: ActionGroupPermissionUserDetail[];
};

export const userPageInitialState: UserPageState = {
  dataAllUserPage: [],
  dataActionPermissionUserDetail: [],

  pagination: {
    pageNumber: Pagination.pageNumber,
    totalPages: 0,
    totalElements: 0,
    pageSize: Pagination.pageSize,
  },
};

export const slice = createSlice({
  name: 'userPage',
  initialState: userPageInitialState,
  reducers: {
    setListUserPageAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: UserPageType[];
        pagination?: PaginationAPI;
        totalElements?: number;
      }>,
    ) {
      state.dataAllUserPage = payload.data;
      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },
    setListDetailUserPageAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: UserPageDetailType;
      }>,
    ) {
      state.dataDetailUserPage = payload.data;
    },
    updateUserPageAction(state, { payload }: PayloadAction<UserPageType>) {
      state.dataAllUserPage = state.dataAllUserPage.map((item) => {
        if (item?.id === payload?.id) {
          return payload;
        }
        return item;
      });
    },
    deleteUserPageAction(state, { payload }: PayloadAction<string>) {
      state.dataAllUserPage = state.dataAllUserPage.filter((item) => item.id !== payload);
    },
    setListPermissionUserDetailAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: FunctionPermissionUserPageType[];
        pagination?: PaginationAPI;
        totalElements?: number;
      }>,
    ) {
      state.dataPermissionsUserDetail = payload.data;
      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },

    setActionsPermissionUserDetailAction(
      state,
      {
        payload,
      }: PayloadAction<{ dataActionPermissionUserDetail: ActionGroupPermissionUserDetail[] }>,
    ) {
      state.dataActionPermissionUserDetail = payload.dataActionPermissionUserDetail;
    },
    addUserWithRoleAction(state, { payload }: PayloadAction<UserPageType>) {
      state.dataAllUserPage = [payload, ...state.dataAllUserPage];
      state.pagination = {
        ...state.pagination,
        pageSize: state.pagination.pageSize + 1,
        totalElements: state.pagination.totalElements + 1,
      };
    },
  },
});

export const {
  setListUserPageAction,
  setListDetailUserPageAction,
  updateUserPageAction,
  deleteUserPageAction,
  setListPermissionUserDetailAction,
  setActionsPermissionUserDetailAction,
  addUserWithRoleAction,
} = slice.actions;

export default slice.reducer;
